import * as LabelPrimitive from "@radix-ui/react-label";
import { forwardRef } from "react";
import { cn } from "../../utils/cn";
import { FIELD_LABEL_CLS } from "../chrome/fieldChrome";

export const Label = forwardRef<
  React.ComponentRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(FIELD_LABEL_CLS, className)} {...props} />
));
Label.displayName = "Label";
